<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <FinancialContractForm
        v-if="Object.keys(contract).length"
        :contract="contract"
      />
      <LoadingPage v-if="!contract" />
    </PageRowWrapper>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import FinancialContractForm from "@/components/settings/financial/contract/FinancialContractForm";
import LoadingPage from "@/components/spinner/LoadingPage";

export default {
  name: "FinancialContractEditView",
  components: {
    PageTitle,
    PageRowWrapper,
    FinancialContractForm,
    LoadingPage,
  },
  computed: {
    ...mapState({
      contract: (state) => state.contracts.contractById,
    }),
  },
  methods: {
    ...mapActions("contracts", ["fetchById"]),
  },
  mounted() {
    this.fetchById(this.$route.params.id);
  },
};
</script>
